<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>礼品管理</span>
          <el-button type="primary" @click="openDialog()" style="float: right" size="small">添加礼品</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="礼品名称">
          <el-input v-model="searchForm.name" placeholder="请输入礼品名称" style="width: 200px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="giftList" style="width: 100%" stripe>
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="name" label="礼品名称" min-width="140"></el-table-column>
        <el-table-column prop="code" label="礼品编码" width="130"></el-table-column>
        <el-table-column prop="price" label="价格" width="90">
          <template slot-scope="scope">¥{{ scope.row.price || 0 }}</template>
        </el-table-column>
        <el-table-column prop="stockLimit" label="禁售上限" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.stockLimit != null ? scope.row.stockLimit : '-' }}</template>
        </el-table-column>
        <el-table-column prop="stock" label="库存" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="lowStock(scope.row) ? 'danger' : 'success'" size="mini">{{ scope.row.stock }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openDialog(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; getGiftList() }"
          @current-change="p => { currentPage = p; getGiftList() }"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="form.id ? '编辑礼品' : '添加礼品'" :visible.sync="dialogVisible" width="550px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="礼品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入礼品名称"></el-input>
        </el-form-item>
        <el-form-item label="礼品编码">
          <el-input v-model="form.code" placeholder="留空自动生成 G开头"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格" prop="price">
              <el-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="form.stock" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="库存提示下限">
          <el-input-number v-model="form.stockLimit" :min="0" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" placeholder="请输入描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { giftApi, applicableTypeApi } from '../api/api'

export default {
  data() {
    return {
      giftList: [],
      applicableTypeList: [],
      searchForm: { name: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: '请输入礼品名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        stock: [{ required: true, message: '请输入库存', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getGiftList()
    this.loadApplicableTypes()
  },
  methods: {
    loadApplicableTypes() {
      applicableTypeApi.getApplicableTypeList(1).then(res => { this.applicableTypeList = res.data || [] })
    },
    getGiftList() {
      giftApi.getGiftPage(this.currentPage, this.pageSize, this.searchForm.name).then(res => {
        this.giftList = res.data.records || []
        this.total = res.data.total || this.giftList.length
      })
    },
    lowStock(row) {
      return row.stockLimit && row.stock <= row.stockLimit
    },
    handleSearch() { this.currentPage = 1; this.getGiftList() },
    openDialog(row) {
      this.loadApplicableTypes()
      this.form = row ? { ...row } : { stock: 0, price: 0, stockLimit: 0, applicableTypeId: null, applicableCount: null }
      this.dialogVisible = true
    },
    handleDelete(id) {
      this.$confirm('确定要删除该礼品吗？', '提示', { type: 'warning' }).then(() => {
        giftApi.deleteGift(id).then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success('删除成功')
            this.getGiftList()
          }
        })
      }).catch(() => {})
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const action = this.form.id ? giftApi.updateGift(this.form) : giftApi.addGift(this.form)
        action.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.getGiftList()
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
</style>
